<template>
  <div>
    <v-dialog v-model="en" scrollable persistent max-width="100%" width="1000">
      <v-card color="white" elevation="0" width="100" height="auto">
        <v-card-title class="w-100">
          <v-spacer></v-spacer>
          <h4>ویرایش برد</h4>
          <v-spacer></v-spacer>
          <v-btn @click="closeCreate" text rounded>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                  outlined
                  label="نام برد"
                  v-model="board.name"
                  :error-messages="getErrorMessage('name')"
              ></v-text-field>
            </v-col>
          <v-col>
            <v-text-field
                outlined
                label="کد"
                v-model="board.code"
                :error-messages="getErrorMessage('code')"
            ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" sm="6" lg="6" class="text-center">
              <h3>سنسور‌ها :</h3>
              <div class=" pt-5">
            <v-list style="max-height: 300px" class="overflow-y-auto">
              <v-row style="padding: 0; margin: 0;" v-for="(device, index) in board.devices" :key="index">
                <v-col cols="1">
                  <div class="mt-3 text-center" style="font-size: 8px;display: grid">{{ index + 1 }}.</div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      dense hide-details filled
                      v-model="board.devices[index]['name']"
                      placeholder="نام نمایشی "
                      @keyup="addNewRow(index)"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <div class="mt-3 text-center" style="font-size: 30px;color: red">:</div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      dense hide-details filled
                      v-model="board.devices[index]['value']"
                      placeholder="نام ارسالی از برد"
                      @keyup="addNewRow(index)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list>
          </div>
            </v-col>
            <v-col cols="12" md="6" sm="6" lg="6" class="text-center">
              <h3>ست پوینت ها :</h3>
              <div class=" pt-5">
                <v-list style="height:500px;max-height: 90%" class="overflow-y-auto">
                  <v-row style="padding: 0; margin: 0;" v-for="(device, index) in board.sets" :key="index">
                    <v-col cols="1">
                      <div class="mt-3 text-center" style="font-size: 8px;display: grid">{{ index + 1 }}.</div>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                          dense hide-details filled
                          v-model="board.sets[index]['name']"
                          placeholder="کد"
                          @keyup="addNewSetRow(index)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1">
                      <div class="mt-3 text-center" style="font-size: 30px;color: red">:</div>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                          dense hide-details filled
                          v-model="board.sets[index]['value']"
                          placeholder="Set Point"
                          @keyup="addNewSetRow(index)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list>
              </div>
            </v-col>
          </v-row>
          <v-sheet class="container" style="border: 1px rgba(0,0,0,0.2) solid" rounded>
            <div class="row">
              <h3 class="mr-5 my-auto">
                توضیحات
              </h3>
              <v-spacer></v-spacer>
              <div>
                <v-btn icon @click="des_show=!des_show">
                  <v-icon v-if="des_show">
                    mdi-arrow-up-drop-circle
                  </v-icon>
                  <v-icon v-else>
                    mdi-arrow-down-drop-circle
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <v-textarea
                v-if="des_show" dense
                hide-details
                class="mt-5"
                v-model="board.descriptions"
                placeholder="افزودن توضیحات برد در صورت نیاز..."
            ></v-textarea>
          </v-sheet>
        </v-card-text>

        <v-card-actions>
          <v-col cols="12">
            <v-btn block large class="elevation-0 text-bold" color="success" @click="sendBoard" :loading="btn_loading">
              ثبت تغییرات
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BoardCreate",
  props: ['board', 'en'],

  data: () => ({
    key: localStorage.getItem('key'),
    errors: {},
    btn_loading: false,
    des_show: false,
  }),

  methods: {
    addNewRow(index) {
      if(this.board.devices.length === index+1){
        if(this.board.devices[index].name && this.board.devices[index].value){
          this.board.devices.push({name:null, value:null})
        }
      }else{
        if(!this.board.devices[index].name && !this.board.devices[index].value){
          if(!this.board.devices[index].name && !this.board.devices[index].value){
            this.$delete(this.board.devices, index);
          }else{
            this.board.devices.pop();
          }
        }
      }
    },

    getErrorMessage(field) {
      if(this.errors){
        return this.errors[field] ? this.errors[field][0] : false;
      }
      return false
    },
    addNewSetRow(index) {
      if(this.board.sets.length === index+1){
        if(this.board.sets[index].name && this.board.sets[index].value){
          this.board.sets.push({name:null, value:null})
        }
      }else{
        if(!this.board.sets[index].name && !this.board.sets[index].value){
          if(!this.board.sets[index].name && !this.board.sets[index].value){
            this.$delete(this.board.sets, index);
          }else{
            this.board.sets.pop();
          }
        }
      }
    },

    async sendBoard() {
      if (this.board.devices.length > 1) {
        this.btn_loading = true;
        this.board.devices.pop();
        this.board.sets.pop()
        try {
          await axios
              .put(`${this.BACKEND_LINK}/api/devices-data/detail/${this.board.id}`, {
                devices: this.board.devices,
                relays: this.board.relays,
                name: this.board.name, 
                code: this.board.code,
                sets: this.board.sets,
                descriptions: this.board.descriptions
              }, {
                headers: {'Authorization': `Token ${this.key}`}
              })
              .then(() => {
                this.$snotify.success('اطلاعات با موفقیت ثبت شد.');
                this.closeCreate()
              })
              .catch((errors) => {
                if (errors.response.data) {
                  this.errors = errors.response.data
                }
                this.$snotify.error(`خطا در ثبت اطلاعات `);
                this.board.devices.push({name: null, value: null});
                this.board.sets.push({name: null, value: null});
              })
              .finally(() => {
                this.btn_loading = false;
              })
        } catch (error) {
          this.$snotify.error(`خطا در ثبت اطلاعات : ${error}`);
          this.btn_loading = false;
          this.board.devices.push({name: null, value: null});
          this.board.sets.push({name: null, value: null});
        }
      } else {
        this.$snotify.error(`حداقل یک سنسور اضافه کنید`);
      }
    },

    closeCreate() {
      this.showCreate = false;
      this.$emit('close');
    },
  },
};
</script>
